import * as React from "react";
import BraintreeButton from "../../../../lib/payments/paypal/BraintreeButton";
import {PurchaseButtonProps} from "./PurchaseButtonProps";

const PayPalPurchaseButton: React.FC<PurchaseButtonProps> = ({purchaseButtonErrors}) => (
  <BraintreeButton
    handleError={purchaseButtonErrors}
    isBlocked={false}
    place="purchase"
    onReturn={() => undefined}
  />
);

export default PayPalPurchaseButton;
